/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import { FastField, getIn } from "formik";
import ErrorIcon from "./ErrorIcon";
import RequiredLabel from "./RequiredLabel";
import configDefaultForm from "./configDefault";
import { useMemo } from "react";
import { FORMAT_DECIMAL_NUMBER } from "app/appConfig";

const GlobitsNumberInput = (props, ref) => (
  <FastField {...props} name={props.name} shouldUpdate={shouldComponentUpdate}>
    {({ field, meta, form }) => (
      <Component {...props} field={field} meta={meta} ref={ref} />
    )}
  </FastField>
);

const Component = forwardRef((props, ref) => {
  const {
    disabled,
    fullWidth = configDefaultForm.fullWidth,
    label,
    name,
    size = configDefaultForm.size,
    type = "number",
    variant = configDefaultForm.variant,
    className = "",
    debounceTime = configDefaultForm.debounceTime,
    notDelay,
    field,
    meta,
    requiredLabel,
    required,
    onChange,
    readOnly,
    InputProps,
    InputLabelProps,
    onFocus,
    value,
    regexInput = /^\d+$/, //default
    decimal = false,
    inputProps,
    maxValue,
    minValue,
    notDefault = configDefaultForm.notDefaultNumber,
    negative,
    isErrorText,
    autoReplaceNumber = false, // chỉ cho nhập số dương
    tabIndex,
    colorText,
    onKeyDown,
    roundNumberToFixed = FORMAT_DECIMAL_NUMBER, // làm tròn sau dấu thập phân
    ...otherProps
  } = props;

  const [values, setValues] = useState(field.value);
  const [t, setT] = useState(undefined);

  useEffect(() => {
    setValues(field.value ?? "");
  }, [field.value]);

  const displayValue = useMemo(() => {
    const num = parseFloat(values);
    if (isNaN(num)) return values;

    if (Number.isInteger(num)) return num.toString();

    return num.toFixed(roundNumberToFixed).replace(/\.?0+$/, "");
  }, [values]);

  const handleChange = (e) => {
    e.persist();
    let eventValue = e.target.value;
    let notChangeValue = false;

    if (eventValue !== "" && !containsOnlyNumbers(eventValue)) {
      notChangeValue = true;
    }

    if (+maxValue && +eventValue > +maxValue) {
      notChangeValue = true;
    }

    if (+eventValue && +minValue && +eventValue < +minValue) {
      notChangeValue = true;
    }

    // if (autoReplaceNumber) {
    //     eventValue = eventValue.replace(/^[0-9]*$/, '');
    // }

    if (autoReplaceNumber) {
      eventValue = eventValue.replace(/[^0-9]/g, "");
      eventValue = eventValue.replace(/^\s+/g, "");
    }

    if (notChangeValue) {
      setValues(field.value ?? "");
      e.preventDefault();
      return;
    }

    if (eventValue === undefined) {
      eventValue = null;
    }

    setValues(eventValue);
    if (t) {
      clearTimeout(t);
    }

    if (notDelay) {
      if (onChange) {
        onChange(e);
      } else {
        field.onChange(e);
      }
    } else {
      setT(
        setTimeout(() => {
          if (onChange) {
            onChange(e);
          } else {
            field.onChange(e);
          }
        }, debounceTime)
      );
    }
  };

  const handleKeyDown = (evt) => {
    let theEvent = evt || window.event;

    //Arrow key
    if (
      theEvent.key === "ArrowUp" ||
      theEvent.key === "ArrowRight" ||
      theEvent.key === "ArrowDown" ||
      theEvent.key === "ArrowLeft"
    ) {
      theEvent.returnValue = true;
      return;
    }

    //backspace, tab, enter
    if (
      theEvent.key === "Backspace" ||
      theEvent.key === "Tab" ||
      theEvent.key === "Enter"
    ) {
      theEvent.returnValue = true;
      return;
    }

    // Ctrl+A or Cmd+A pressed?
    if (
      (theEvent.ctrlKey || theEvent.metaKey) &&
      (theEvent.key === "a" || theEvent.key === "A")
    ) {
      theEvent.returnValue = true;
      return;
    }

    // Ctrl+C or Cmd+C pressed?
    if (
      (theEvent.ctrlKey || theEvent.metaKey) &&
      (theEvent.key === "c" || theEvent.key === "C")
    ) {
      theEvent.returnValue = true;
      return;
    }

    // Ctrl+V or Cmd+V pressed?
    if (
      (theEvent.ctrlKey || theEvent.metaKey) &&
      (theEvent.key === "v" || theEvent.key === "V")
    ) {
      theEvent.returnValue = true;
      return;
    }

    // Ctrl+X or Cmd+X pressed?
    if (
      (theEvent.ctrlKey || theEvent.metaKey) &&
      (theEvent.key === "x" || theEvent.key === "X")
    ) {
      theEvent.returnValue = true;
      return;
    }

    // Ctrl+Z or Cmd+Z pressed?
    if (
      (theEvent.ctrlKey || theEvent.metaKey) &&
      (theEvent.key === "z" || theEvent.key === "Z")
    ) {
      theEvent.returnValue = true;
      return;
    }

    let eventValue = theEvent.target.value;
    //cho phép thập phân
    if (
      decimal &&
      theEvent.key === "." &&
      eventValue !== null &&
      eventValue !== undefined &&
      eventValue !== ""
    ) {
      theEvent.returnValue = true;
      return;
    }

    //cho phep nhap so am
    if (negative && theEvent.key === "-" && !eventValue) {
      theEvent.returnValue = true;
      return;
    }

    // Delete
    if (theEvent.key === "Delete") {
      theEvent.returnValue = true;
      return;
    }

    if (!regexInput.test(theEvent.key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) {
        theEvent.preventDefault();
      }
    }
  };

  const displayLabel = useMemo(
    () =>
      label ? (
        <RequiredLabel
          label={label}
          requiredLabel={required || requiredLabel}
        />
      ) : null,
    [label, required, requiredLabel]
  );
  const isError = meta && meta.touched && meta.error;

  return (
    <>
      {!fullWidth && displayLabel && (
        <label htmlFor={name}>{displayLabel}</label>
      )}
      <TextField
        {...otherProps}
        {...field}
        ref={ref}
        id={name}
        // name={name}
        disabled={disabled}
        fullWidth={fullWidth}
        label={fullWidth && displayLabel ? displayLabel : null}
        size={size}
        type={type}
        variant={variant}
        value={displayValue ?? ""}
        onChange={handleChange}
        onKeyDown={onKeyDown ? onKeyDown : handleKeyDown}
        error={isError}
        helperText={fullWidth && isError ? meta.error : ""}
        onFocus={(event) => {
          event.target.inputMode = "numeric";
          if (onFocus) {
            onFocus(event);
          }
        }}
        InputProps={{
          readOnly: readOnly,
          ...InputProps,
          style: {
            color: colorText,
            fontWeight: colorText ? "bolder" : "inherit",
          },
        }}
        InputLabelProps={{
          htmlFor: name,
          shrink: true,
          ...InputLabelProps,
        }}
        inputProps={{
          ...inputProps,
          style: {
            textAlign: notDefault ? "left" : "right",
            color: !notDefault && "#A94442",
            backgroundColor: disabled && !notDefault && "#f8f8f8",
          },
          tabIndex: tabIndex,
        }}
        defaultValue={!notDefault ? 0 : ""}
        className={`input-container ${
          readOnly ? "read-only" : ""
        } ${className}  ${isErrorText ? "text-field-error" : ""}`}
      />
      {isError && !fullWidth && <ErrorIcon helperText={meta.error} />}
    </>
  );
});

const containsOnlyNumbers = (str) => /^[\d.-]+$/.test(str);

const shouldComponentUpdate = (nextProps, currentProps) =>
  nextProps.name !== currentProps.name ||
  nextProps.value !== currentProps.value ||
  nextProps.onChange !== currentProps.onChange ||
  nextProps.label !== currentProps.label ||
  nextProps.required !== currentProps.required ||
  nextProps.disabled !== currentProps.disabled ||
  nextProps.readOnly !== currentProps.readOnly ||
  nextProps.className !== currentProps.className ||
  nextProps.onBlur !== currentProps.onBlur ||
  nextProps.formik.isSubmitting !== currentProps.formik.isSubmitting ||
  Object.keys(nextProps).length !== Object.keys(currentProps).length ||
  getIn(nextProps.formik.values, currentProps.name) !==
    getIn(currentProps.formik.values, currentProps.name) ||
  getIn(nextProps.formik.errors, currentProps.name) !==
    getIn(currentProps.formik.errors, currentProps.name) ||
  getIn(nextProps.formik.touched, currentProps.name) !==
    getIn(currentProps.formik.touched, currentProps.name);

export default React.memo(forwardRef(GlobitsNumberInput));
